import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import CollaboratorsVacations from "./CollaboratorsVacations";

const CallCollaboratorsVacations = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <CollaboratorsVacations />
        </div>
    );
}

export default CallCollaboratorsVacations;